import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
const list = [
  {
    path: '/helpCenter',
    component: HeaderAsideLayout,
    children: [
      { path: '/helpCenter', component: () => import('@/pages/helpCenter/index.vue') },
    ],
  },
]
export default list